module.exports = __webpack_public_path__ + "img/Philippines.ab9dc661.png";